import { FieldControl } from '@signature-it/ngx-generic/enums';
import {SelectField} from "./select";

export class FlatSelectImgOnlyField extends SelectField {
    controlType = FieldControl.FLAT_SELECT_IMG_ONLY;
    popupFlatSelectImgOnly: boolean = false;
    constructor(options: {} = {}) {
        super(options);
        if(options['controlType'] == FieldControl.POPUP_FLAT_SELECT_IMG_ONLY){
            this.popupFlatSelectImgOnly = true;
        }
        this.dynamicOptions = true;
    }
}
